import { LoadingContainer } from 'components/loadingContainer'
import { Cart } from 'features/user/Ticket'
import { useEventById } from 'hooks/admin/useEvents'
import { useParams } from 'react-router-dom'

export const CartPage = () => {
    const { eventId } = useParams()

    const { data: currentEvent, isLoading, error } = useEventById(eventId || '')

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            {currentEvent && <Cart currentEvent={currentEvent} />}
        </LoadingContainer>
    )
}
